module.exports = __webpack_public_path__ + "img/listing-5.e2b4b07.jpg";